export enum FacilityType {
  SkilledNursing = 'SKILLED_NURSING',
  AssistedLiving = 'ASSISTED_LIVING',
  CCRC = 'CCRC',
  IndependentLiving = 'INDEPENDENT_LIVING',
  MemoryCare = 'MEMORY_CARE',
}
